/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Fallback_User_Quota_ExceededInputs */



/**
* | output |
* | --- |
* | "Your personal quota has been reached. This response used oneAI Standard (free)." |
*
* @param {Chat_Fallback_User_Quota_ExceededInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_fallback_user_quota_exceeded = /** @type {((inputs?: Chat_Fallback_User_Quota_ExceededInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Fallback_User_Quota_ExceededInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dein persönliches Kontingent wurde erreicht. Diese Antwort verwendete oneAI Standard (kostenlos).")
	return /** @type {LocalizedString} */ ("Your personal quota has been reached. This response used oneAI Standard (free).")
});